import { createReducer } from "@reduxjs/toolkit";
import type { UploadState } from "@redux/state/shared-types";
import { uploadExternalProviderInvoice, resetUploadExternalProviderInvoice } from "./upload-external-provider-invoice";

const initialState: UploadState = { processing: "idle", url: null };

export const uploadExternalProviderInvoiceReducer = createReducer<UploadState>(initialState, builder => {
  builder
    .addCase(uploadExternalProviderInvoice.fulfilled, (state, action) => {
      return {
        ...state,
        processing: "success",
        url: action.payload,
      };
    })
    .addCase(uploadExternalProviderInvoice.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(uploadExternalProviderInvoice.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetUploadExternalProviderInvoice, () => {
    return initialState;
  });
});
